import React from 'react';
import PropTypes from 'prop-types';

export const LineBreak: React.FC<React.ComponentPropsWithoutRef<'br'>> = ({
    className,
    ...rest
}) => <br {...rest} className={className} />;

LineBreak.displayName = 'LineBreak';
LineBreak.propTypes = {
    className: PropTypes.string,
};
